import {Injectable} from '@angular/core';
import {GeneralService} from './general.service';
import {HttpClient} from '@angular/common/http';
import {User, UserBackend} from '../interfaces/user';
import {ServiceAnswer, ServiceAnswerAny} from '../../shared/service-answer';
import {map} from 'rxjs/operators';
import {UiSettingsService} from '../../shared/ui-settings.service';
import { SuperuserServiceModule } from '../superuser-service.module';

@Injectable({
  providedIn: SuperuserServiceModule
})
export class UserService extends GeneralService<User> {

  /**
   * Creates the service.
   * @param http Http client for rest.
   * @param messageService Service that is used for messages.
   */
  constructor(http: HttpClient, uiSettingService: UiSettingsService) {
    super(http, uiSettingService, 'allusers', 'alluser');
  }

  /**
   * User with given id is sent and request to change his/her password.
   * @param userId The id of the user whose password should be changed.
   */
  async requestPasswordChange(userId: string, tenantId: number): Promise<ServiceAnswerAny> {
    const serviceAnswer: ServiceAnswerAny = {isOk: null};

    try {
      const response = await this.http.get(
        super.getUrlFromSelectedContext(userId) + `requestpasswordchange/?tenantId=${tenantId}`,
        {
        })
        .pipe(
          map((value: any) => {
            return JSON.stringify(value);
          }))
        .toPromise();
      serviceAnswer.isOk = true;
      serviceAnswer.data = JSON.parse(response);
      return serviceAnswer;
    } catch (error) {
      console.error(`Error when requesting password change for user ${userId}: ${JSON.stringify(error)}`);
      serviceAnswer.isOk = false;
      serviceAnswer.errorCode = error.status;
      serviceAnswer.errorMessage = error.message + '. Answer body: ' + JSON.stringify(error.error);
      return serviceAnswer;
    }
  }

  /**
   * Adds the given entity with rest.
   * @param {ENTITY} entity The entity to be added.
   * @returns {Promise<ServiceAnswerAny>} The answer of the rest webservice call. If the call was successful then this contains also
   * the requested data.
   */
  async addEntity(entity: User, restParameters?: { key: string, value: string }[]): Promise<ServiceAnswerAny> {
    const userBackend: UserBackend = {};

    userBackend.name = entity.name;
    userBackend.password = 'jsdfUlsjr39LKJ';
    userBackend.email_verified = entity.email_verified;
    userBackend.email = entity.email;
    userBackend.app_metadata = entity.app_metadata;

    return super.addEntity(userBackend, restParameters);
  }

  /**
   * Adds the given entity with rest.
   * @param {ENTITY} entity The entity to be added.
   * @returns {Promise<ServiceAnswerAny>} The answer of the rest webservice call. If the call was successful then this contains also
   * the requested data.
   */
  async modifyEntity(entity: User, entityId: any, restParameters?: { key: string, value: string }[]): Promise<ServiceAnswerAny> {
    const userBackend: UserBackend = {};

    userBackend.name = entity.name;
    userBackend.groups = entity.app_metadata['right_groups'];
    return super.modifyEntity(userBackend, entity.user_id, restParameters);
  }
}
